module.exports = __webpack_public_path__ + "img/allStars_logo_white.eae3f109.png";